<div class="wrapper">
    <app-appli-side-bar [sidebars]="sidebar" (clickEventIndex)="setFocusIndex($event)"></app-appli-side-bar>
    <div class="top_icon"></div>
    <div class="app_name">{{ appname }}</div>
    <div class="remote_control"></div>
    <div class="datetime">
        {{ now_date_obj.year }}.{{ now_date_obj.month }}.{{ now_date_obj.day }} {{ now_date_obj.hhmm }}
    </div>
    <div class="main_content_wrapper">
        <div class="main_content">
            <!-- Breakfast -->
            <div *ngIf="hotelIndex == 0">
                <div>
                    <div class="ja" *ngIf="lang == 'jpn'">
                        <img src="/assets/breakfast/breakfast_jp_2.jpg">
                    </div>
                    <div class="en" *ngIf="lang == 'eng'">
                        <img src="/assets/breakfast/breakfast_eg_2.jpg">
                    </div>
                </div>
            </div>
            <!-- Lunch-->
            <div *ngIf="hotelIndex == 1">

                <div>
                    <div class="ja" *ngIf="lang == 'jpn'">
                        <img src="/assets/breakfast/lunchdinner_jp.png">
                    </div>
                    <div class="en" *ngIf="lang == 'eng'">
                        <img src="/assets/breakfast/lunchdinner_en.png">
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>